import { render, staticRenderFns } from "./LegalDocumentFormDetails.vue?vue&type=template&id=24b45502&scoped=true&"
import script from "./LegalDocumentFormDetails.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentFormDetails.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentFormDetails.vue?vue&type=style&index=0&id=24b45502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b45502",
  null
  
)

export default component.exports